import { render, staticRenderFns } from "./commonGoodsSecondClass.vue?vue&type=template&id=288eae7c"
import script from "./commonGoodsSecondClass.vue?vue&type=script&lang=ts"
export * from "./commonGoodsSecondClass.vue?vue&type=script&lang=ts"
import style0 from "./commonGoodsSecondClass.vue?vue&type=style&index=0&id=288eae7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports